import { useFiltersParam as useFiltersParamBase } from '../../../../hooks/search-params/use-filters-param';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';

export function useFiltersParam() {
  return useFiltersParamBase<FilterLineType>('contractFilters');
}
